import { VariableType } from 'json-to-graphql-query';

import { CoachFilters } from '@/interfaces/filters/coachFilters';
import { PlayerFilters } from '@/interfaces/filters/playerFilters';
import { ProfileFilters } from '@/interfaces/filters/profileFilters';
import { Profile } from '@/interfaces/profile';
import { EntityResource } from './entity.resource';

/**
 * Resource profili
 *
 * @export
 * @class ProfileResource
 * @extends {EntityResource<Profile>}
 */
export class ProfileResource extends EntityResource<Profile> {
  public getFields = {
    id: true,
    email: true,
    firstName: true,
    lastName: true,
    phoneNumber: true,
    birthDate: true,
    education: true,
    jobHistory: true,
    achievements: true,
    images: true,
    lang: true
  };

  public listFields = {
    id: true,
    email: true,
    firstName: true,
    lastName: true,
    phoneNumber: true
  };

  protected listVariables = { filters: 'ProfileFilters' };

  constructor() {
    super({
      entityName: 'profile'
    });
  }

  /**
   * Pobiera liste trenerów
   *
   * @param {CoachFilters} filters
   * @returns
   * @memberof ProfileResource
   */
  public coachList(filters: CoachFilters) {
    this.listQueryName = 'coachList';
    this.listVariables.filters = 'CoachFilters!';
    return super.list(filters);
  }

  /**
   * Pobiera liste zawodników
   *
   * @param {PlayerFilters} filters
   * @returns
   * @memberof ProfileResource
   */
  public playersList(filters: PlayerFilters) {
    this.listQueryName = 'playersList';
    this.listVariables.filters = 'PlayersFilters!';
    return super.list(filters);
  }

  /**
   * Pobiera liste profilów
   *
   * @param {ProfileFilters} filters
   * @returns
   * @memberof ProfileResource
   */
  public list(filters: ProfileFilters) {
    this.listQueryName = 'profileList';
    this.listVariables.filters = 'ProfileFilters';

    return super.list(filters);
  }

  /**
   * Aktualizuje język interfejsu profilu
   *
   * @param {number} id
   * @param {string} lang
   * @returns {Promise<boolean>}
   * @memberof ProfileResource
   */
  public langUpdate(profileId: number, lang: string): Promise<boolean> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { profileId: 'Int!', lang: 'String!' },
        langUpdate: { __args: { profileId: new VariableType('profileId'), lang: new VariableType('lang') } }
      }
    });
    return this.mutation({ mutation, variables: { profileId, lang } }, 'langUpdate');
  }
}

export const profileResource = new ProfileResource();
